import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-500f5406"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_download_document = _resolveComponent("download-document")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _createVNode(_component_download_document, { downloadData: { title: 'FAQ', isImage: false, date: '2021-08-12' } })
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_download_document, { downloadData: {
          title: 'Preliminary cost estimate',
          isImage: false,
          date: '2021-08-12',
        } })
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_download_document, { downloadData: {
          title: 'damage.png',
          isImage: true,
          date: '2021-08-12',
        } }, null, 8, ["downloadData"])
    ])
  ]))
}